import React, { useContext, useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';

import { Container, Grid, LinearProgress } from '@mui/material';
import { PageHeader } from '../../common';
import { FetchContext, NavContext, NavRoutes } from '../../contexts';
import { TipoUfficioContext, TipoUfficioProvider } from './TipoUfficioContext';
import { TipiList, TipoDetails } from './components';

const PageContent = (props) => {

    const {
        user
    } = useContext(FetchContext);

    const {
        addBreadcrumbToken,
        setBread,
        goBack,
        navigateTo,
    } = useContext(NavContext);

    const {
        state,
        setState,

        isLoadingTipo,
        getTipoAsync,

        isLoadingTipi,
        getTipiAsync,

        isDeletingTipo,
        deleteTipoAsync,

        isUpdatingTipo,
        updateTipoAsync,

        isAddingTipo,
        addTipoAsync,

        isLoadingFiles,
        getFilesAsync,

        isLoadingCompetenze,
        getCompetenzeAsync,
    } = useContext(TipoUfficioContext)

    const {
        tipo,
    } = state;

    const {
        tipoUfficioId,
    } = useParams();

    const formRef = useRef();
    const saveClickHandler = () => {
        if (formRef.current) {
            formRef.current.handleSubmit();
        }
    }

    const tipoDetailsActionClickHandler = async (action, data) => {
        switch (action) {
            case "Submit":
                if (tipoUfficioId) {
                    if (window.confirm("Confermare la modifica?")) {
                        await updateTipoAsync(tipoUfficioId, data);
                    }
                } else {
                    if (window.confirm("Confermare l'inserimento?")) {
                        await addTipoAsync(data);
                        goBack();
                    }
                }
                break;
            default:
                break;
        }
    }

    const tipiListActionClickHandler = async (action, data) => {
        switch (action) {
            case "Add":
                window.open(NavRoutes.TipoUfficioAdd, "_blank").focus();
                break;
            case "Delete":
                if (window.confirm("Confermare l'eliminazione?")) {
                    await deleteTipoAsync(data.id);
                }
                break;
            default:
                break;
        }
    }

    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        setIsLoading(isLoadingTipo || isAddingTipo || isUpdatingTipo);
    }, [isLoadingTipo, isAddingTipo, isUpdatingTipo])

    useEffect(() => {
        if (user && tipo)
            addBreadcrumbToken(tipo.nome);
    }, [tipo, user]);

    useEffect(() => {
        if (user) {
            if (tipoUfficioId) {
                getTipoAsync(tipoUfficioId);
                getTipiAsync(0, 1000, tipoUfficioId);
            } else {
                addBreadcrumbToken("Aggiungi");
                setState({ tipo: { padreId: tipo?.id }, tipi: null });
            }
            getFilesAsync(0, 1000);
        }
    }, [tipoUfficioId, user]);

    return (
        <>
            <Container>
                {isLoading && <LinearProgress />}
                <Grid container>
                    <Grid item xs={12}>
                        <PageHeader
                            save
                            onSaveClick={saveClickHandler}
                            disabled={isLoading}
                            title="Tipo ufficio"
                            subtitle="Gestisci il tipo ufficio" />
                    </Grid>
                    <Grid item xs={12}>
                        <TipoDetails
                            disabled={isLoading}
                            formRef={formRef}
                            onActionClick={tipoDetailsActionClickHandler} />
                        {
                            tipoUfficioId && <TipiList
                                disabled={isLoading}
                                onActionClick={tipiListActionClickHandler} />
                        }
                    </Grid>
                </Grid>
            </Container>
        </>
    );
}

export const TipoUfficioPage = () => {

    return (
        <TipoUfficioProvider>
            <PageContent />
        </TipoUfficioProvider>
    );
}